import React from "react";
import { formatCompactEuro, formatPct } from "./formatters";
import styles from "./DossierDashboard.module.scss";

const MarginAnalysis = ({ stats, onScrollTo }) => {
  const { rows, totalOverDuration, weightedRate } = stats.margins;
  if (rows.length === 0) return null;
  const maxRate = rows.reduce((m, r) => Math.max(m, r.rate), 0);
  return (
    <div className={styles.sect}>
      <div className={styles.sectTitle}>
        <span>
          Marges <i className="fa fa-lock" title="Masqué aux rôles commerciaux" />
        </span>
        <span className={styles.sectTitleRight}>
          total {formatCompactEuro(totalOverDuration)} · moy. pondérée{" "}
          {formatPct(weightedRate)}
        </span>
      </div>
      {rows.map((r) => (
        <button
          key={r.index}
          type="button"
          className={styles.barRow}
          onClick={() => onScrollTo(r.index)}
          title={`${r.reference} — aller au devis`}
        >
          <span className={styles.barName}>{r.reference}</span>
          <span className={styles.barTrack}>
            <span
              className={`${styles.barFill} ${r.isLow ? styles.barFillLow : ""}`}
              style={{
                width: maxRate > 0 ? (r.rate / maxRate) * 100 + "%" : 0,
                display: "block",
              }}
            />
          </span>
          <span
            className={`${styles.barValue} ${r.isLow ? styles.barValueLow : ""}`}
          >
            {formatPct(r.rate)}
            {r.isLow && <i className="fa fa-exclamation-triangle ml-1" />}
          </span>
        </button>
      ))}
      <div className={styles.note}>
        <i className="fa fa-exclamation-triangle mr-1" />= à moins de 1 pt du
        taux minimum autorisé
      </div>
    </div>
  );
};

export default MarginAnalysis;
